import styled from "styled-components";
import { mobile } from "../../ui/media";

export const Page = styled.div`
  flex: 1;
  background: ${({ theme }) => theme.colors.background.app};
  padding: ${({ theme }) => `${theme.spacing(4)} ${theme.spacing(3)}`};

  ${mobile} {
    padding: ${({ theme }) => `${theme.spacing(2)} ${theme.spacing(2)}`};
  }
`;

export const Inner = styled.div`
  max-width: 720px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(3)};
`;

export const Title = styled.h1`
  margin: 0;
  font-family: ${({ theme }) => theme.typography.headingFamily};
  font-size: ${({ theme }) => theme.typography.h1};
  letter-spacing: -0.02em;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const Card = styled.section`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  padding: ${({ theme }) => theme.spacing(3)};
  border-radius: ${({ theme }) => `${theme.radius.lg}px`};
  background: ${({ theme }) => theme.colors.background.surface};
  border: 1px solid ${({ theme }) => theme.colors.border.subtle};

  ${mobile} {
    padding: ${({ theme }) => theme.spacing(2)};
  }
`;

export const CardTitle = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.typography.headingFamily};
  font-size: ${({ theme }) => theme.typography.h3};
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const CardHint = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.small};
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const Row = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
  gap: ${({ theme }) => theme.spacing(2)};
`;

export const Field = styled.label`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.75)};
  font-size: ${({ theme }) => theme.typography.small};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.text.primary};
`;

export const TextInput = styled.input`
  min-height: ${({ theme }) => theme.spacing(6)};
  padding: 0 ${({ theme }) => theme.spacing(1.5)};
  border-radius: ${({ theme }) => `${theme.radius.sm}px`};
  border: 1px solid ${({ theme }) => theme.colors.input.border};
  background: ${({ theme }) => theme.colors.input.bg};
  color: ${({ theme }) => theme.colors.text.primary};
  font-family: inherit;
  font-size: ${({ theme }) => theme.typography.body};
  font-weight: 400;

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.accent.primary};
    box-shadow: 0 0 0 3px ${({ theme }) => theme.colors.state.selected};
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }
`;

export const Actions = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${({ theme }) => theme.spacing(1)};
`;

export const FieldError = styled.span`
  font-size: ${({ theme }) => theme.typography.small};
  font-weight: 600;
  color: ${({ theme }) => theme.colors.accent.danger};
`;

export const ReadOnlyValue = styled.span`
  min-height: ${({ theme }) => theme.spacing(6)};
  display: flex;
  align-items: center;
  padding: 0 ${({ theme }) => theme.spacing(1.5)};
  border-radius: ${({ theme }) => `${theme.radius.sm}px`};
  border: 1px dashed ${({ theme }) => theme.colors.border.subtle};
  background: ${({ theme }) => theme.colors.background.surfaceAlt};
  color: ${({ theme }) => theme.colors.text.secondary};
  font-weight: 400;
  word-break: break-all;
`;

export const Skeleton = styled.div`
  height: ${({ theme }) => theme.spacing(20)};
  border-radius: ${({ theme }) => `${theme.radius.lg}px`};
  background: ${({ theme }) => theme.colors.background.surfaceAlt};
  border: 1px solid ${({ theme }) => theme.colors.border.subtle};
`;
